export default {
	accessRejections: {
		subtitle: 'People who have rejected the terms of use or the privacy policy',
		unknownPerson: 'Unknown Person',
		openSinceOneDay: 'for 1 day',
		openSinceDays: 'for {count} days',
		openSinceNone: '–',
		status: {
			locked: 'Locked',
			pendingSync: 'Released, awaiting sync',
			stuck: 'Stuck for {count} days',
			waitingErp: 'Awaiting privacy release in ERP',
			done: 'Data restored',
			error: 'Sync-back failed',
		},
		nomailHint:
			'Automatic sending of access credentials is disabled (Administration › Email). After the data is restored, the person will not automatically receive an access letter – send it yourself via "Accesses".',
		actions: {
			details: 'Details',
			forget: 'Forget Case',
		},
		release: {
			title: 'Release Access',
			text: "The lock is lifted. During the next sync run, the person's data will be restored from the ERP system. The person will then receive a new access letter and must accept the terms of use and privacy policy again.",
			textNoMail:
				"The lock is lifted. During the next sync run, the person's data will be restored from the ERP system. The person must accept the terms of use and privacy policy again.",
			hintNoMail:
				'Note: Automatic sending of access credentials is disabled. You must send the access letter yourself via "Accesses" after the data is restored.',
			toast: 'Access released. The data will be restored on the next sync run.',
		},
		forget: {
			title: 'Forget Case',
			text: 'The tombstone and lock disappear permanently. The person will be uploaded again completely normally on the next sync run and automatically invited, provided they are active in the ERP system – without renewed consent. This action cannot be undone.',
			toast:
				'Case removed. The person will be transferred again on the next sync run.',
		},
		case: {
			title: 'Case {name}',
			historyTitle: 'History',
			history: {
				rejectedAt: 'Access rejected',
				releasedAt: 'Released',
				syncClaimedAt: 'Picked up by the sync service',
				syncAckedAt: 'Sync service response: {result}',
				erpPrivacyCheckedAt: 'Privacy release checked in ERP: {value}',
				purgeDoneAt: 'Cleanup completed',
			},
			erpReleased: 'released',
			erpNotReleased: 'not released',
			syncResult: {
				ok: 'Data restored',
				no_erp_release: 'Privacy release missing in ERP',
				not_found: 'Person not found in ERP',
				error: 'Error',
			},
			messageTitle: 'Sync service message',
			messageEmpty: 'No response from the sync service yet.',
		},
	},
}
